exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,html{padding:0;margin:0}html{font-size:1em;font-family:Courier New}body{font-size:100%}:link img,:visited img,a img{border:0}*,:after,:before{box-sizing:border-box}*{margin:0;padding:0;border:0 none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?{ browsers: ['last 100 versions'] }!./src/css/reset.css
// module id = 108
// module chunks = 0